import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var UnderscorePipe = (function () {
    function UnderscorePipe() {
    }
    UnderscorePipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.trim()
                .replace(/\s+/g, '')
                .replace(/[A-Z]/g, function (c, k) {
                return k ? "_" + c.toLowerCase() : c.toLowerCase();
            })
            : text;
    };
    UnderscorePipe.decorators = [
        { type: Pipe, args: [{ name: 'underscore' },] },
    ];
    /** @nocollapse */
    UnderscorePipe.ctorParameters = function () { return []; };
    return UnderscorePipe;
}());
export { UnderscorePipe };
//# sourceMappingURL=underscore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/underscore.js
// module id = 295
// module chunks = 4